// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bgw_a bhm_ea bhm_a","LoadingSwitch__init":"bgw_b bhm_a bhm_w bhm_j bhm_ul bhm_um bhm_fm"};